module.exports = __webpack_public_path__ + "img/bluetooth-on.f20170a1.svg";